// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__o4vED","balanceDisclaimer":"posDashboard_balanceDisclaimer__1750a"};